import { Typography } from '@mui/material';
import { DescriptionStep } from '@/packages/subsidy/pages/refund-request/components/step-wrapper';
import { useRefundRequest } from '@/packages/subsidy/pages/refund-request/context';
import { formatDate } from '@/utils/format-date';

export const Payment = () => {
  const { getStepState, resourceApproval } = useRefundRequest();
  const { status, disabled } = getStepState(5);

  const paymentDate = resourceApproval?.refund_request?.refund?.paid_at;
  const formattedDate = formatDate(paymentDate);

  const description = paymentDate
    ? `Pago em ${formattedDate}`
    : 'Aguardando pagamento';

  return (
    <DescriptionStep
      title="5. Pagamento"
      stepStatus={status}
      disabled={disabled}
      description={<Typography>{description}</Typography>}
    />
  );
};
